import "./CardiacEvaluations.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function CardiacEvaluationsPage() {
  return <div>
      <Header />
      <section className="bg-[var(--color-dark-navy)] pt-32 pb-16 px-6 lg:px-12 font-default">
        <p className="text-sm uppercase tracking-widest text-red-500 mb-4">Services</p>
        <h1 className="font-bold text-3xl md:text-4xl uppercase tracking-tight text-white mb-6">Cardiac Evaluations</h1>
        <p className="text-lg text-soft-gray max-w-3xl">Whether it is preventive or intended to help diagnose a condition, a cardiac evaluation can provide important information about your heart health. At Florida Premier Cardiology, Dr. Carrillo-Jimenez provides personalized evaluations and diagnostic testing based on each patient's needs.</p>
        <p className="text-lg text-soft-gray max-w-3xl mt-4">We have locations in Boynton Beach and Delray Beach.</p>
      </section>
      <section className="bg-background text-foreground py-16 px-6 lg:px-12 font-default">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Evaluating All Cardiac Conditions Including</h2>
            <ul className="list-disc list-inside text-base text-soft-gray leading-relaxed space-y-2">
              <li>Chest pain</li>
              <li>Fainting spells</li>
              <li>Palpitations</li>
              <li>Shortness of breath</li>
              <li>Dizziness</li>
              <li>Limb pain</li>
            </ul>
          </div>
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Understanding Your Unique Needs</h2>
            <p className="text-base text-soft-gray leading-relaxed">We perform a stress test to find out how your heart reacts to external stress. We may also conduct an echo test, which uses sound waves to create images of your heart's chambers, valves, walls, and blood vessels.</p>
            <p className="text-base text-soft-gray leading-relaxed mt-4">At our clinic, we understand that no two cardiac patients are alike. Our entire staff is focused on providing personalized care and treating you as a whole person, not just a condition.</p>
          </div>
        </div>
      </section>
      <section className="bg-[var(--color-dark-navy)] py-16 px-6 lg:px-12 font-default text-center">
        <p className="text-white text-lg max-w-2xl mx-auto mb-8">If you are experiencing any of the symptoms above, or simply want to stay ahead of your heart health, schedule a cardiac evaluation with us today.</p>
        <Link to="/contact-us/" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">Contact Us</Link>
      </section>
      <Footer />
    </div>;
}
